document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('[data-personalizar-sabores]');
  if (!container) return;

  try {
    var _d = window.__LB_DISTINCT_ID__;
    if (_d) {
      fetch('https://api.liquidz.com.br/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event: 'lb_painel_action', distinct_id: _d, properties: { action: 'customize_view' } }),
      });
      fetch('https://api.liquidz.com.br/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event: 'lb_action_customize_view', distinct_id: _d }),
      });
    }
  } catch (e) {}

  var saveBtn = container.querySelector('[data-save-flavors]');
  var totalCaixas = parseInt(container.getAttribute('data-subscription-total')) || 0;
  var MAX_CAIXAS = 8;
  var originalSabores = {}; // snapshot da assinatura ao carregar
  var c26Boxes = {}; // { handle: { qty, price, sku, name, img } } — caixas add-on C26
  var c26Removals = []; // [{ handle, sku }] — C26 marcados para remoção nesta sessão
  var c26PendingAdd = null; // { handle, sku, name, price } — oferta C26 aceita pelo usuário (aguardando save)
  var promoMode = 'normal'; // 'normal' | '4locked' | 'promo12'
  var promoDiscount = 0;   // desconto da campanha ativa (ex: 0.30)
  var armUnitPrice = 0;    // preço por caixa do arm de teste (centavos); 0 = usar data-sabor-price
  var C26_FALLBACK_IMG = { uva: 'https://cdn.shopify.com/s/files/1/0837/5153/4895/files/liquidz-uva_1.webp?v=1781011000', laranja: 'https://cdn.shopify.com/s/files/1/0837/5153/4895/files/laranja.webp?v=1789395784' };

  // ========================================
  // 1. Event delegation para todos os botões
  // ========================================
  container.addEventListener('click', function(e) {
    var trashBtn = e.target.closest('[data-c26-remove]');
    if (trashBtn) { handleC26Remove(trashBtn); return; }

    var offerBtn = e.target.closest('[data-c26-offer-add]');
    if (offerBtn) { handleC26OfferAdd(); return; }

    var btn = e.target.closest('[data-action]');
    if (!btn) return;

    var action = btn.getAttribute('data-action');
    var qtyContainer = btn.closest('[data-sabor-qty]');
    if (!qtyContainer) return;

    if (action === 'add') {
      handleAdd(qtyContainer);
    } else if (action === 'increase') {
      handleIncrease(qtyContainer);
    } else if (action === 'decrease') {
      handleDecrease(qtyContainer);
    }

    updateSaveButton();
  });

  // ========================================
  // 2. Ações dos botões
  // ========================================

  function handleAdd(qtyContainer) {
    if (getSomaTotal() >= MAX_CAIXAS) return;
    qtyContainer.innerHTML = buildQtyControls(1);
  }

  function handleIncrease(qtyContainer) {
    if (getSomaTotal() >= MAX_CAIXAS) return;
    var valueEl = qtyContainer.querySelector('[data-qty-value]');
    if (!valueEl) return;
    var current = parseInt(valueEl.textContent) || 0;
    valueEl.textContent = current + 1;
  }

  function handleDecrease(qtyContainer) {
    var valueEl = qtyContainer.querySelector('[data-qty-value]');
    if (!valueEl) return;
    var current = parseInt(valueEl.textContent) || 0;

    if (current <= 1) {
      qtyContainer.innerHTML = buildAddButton();
    } else {
      valueEl.textContent = current - 1;
    }
  }

  // ========================================
  // 3. Builders de HTML
  // ========================================

  function buildQtyControls(qty) {
    return '<button type="button" class="personalizar-sabor__qty-btn personalizar-sabor__qty-minus" data-action="decrease" aria-label="Diminuir">-</button>'
      + '<span class="personalizar-sabor__qty-value" data-qty-value>' + qty + '</span>'
      + '<button type="button" class="personalizar-sabor__qty-btn personalizar-sabor__qty-plus" data-action="increase" aria-label="Aumentar">+</button>';
  }

  function buildAddButton() {
    return '<button type="button" class="personalizar-sabor__qty-add" data-action="add" aria-label="Adicionar">Adicionar</button>';
  }

  // ========================================
  // 4. Validação e estado do botão salvar
  // ========================================

  function getSomaTotal() {
    var total = 0;
    container.querySelectorAll('.personalizar-sabor [data-qty-value]').forEach(function(el) {
      total += parseInt(el.textContent) || 0;
    });
    return total;
  }

  function getSelectedFlavors() {
    var flavors = [];
    container.querySelectorAll('.personalizar-sabor:not([data-c26-promo])').forEach(function(card) {
      var valueEl = card.querySelector('[data-qty-value]');
      if (!valueEl) return;
      var qty = parseInt(valueEl.textContent) || 0;
      if (qty > 0) {
        flavors.push({
          handle: card.getAttribute('data-sabor-handle'),
          title: card.getAttribute('data-sabor-title'),
          quantity: qty
        });
      }
    });
    return flavors;
  }

  function hasChanges() {
    if (c26Removals.length > 0 || c26PendingAdd) return true;
    var changed = false;
    container.querySelectorAll('.personalizar-sabor:not([data-c26-promo])').forEach(function(card) {
      var handle = card.getAttribute('data-sabor-handle');
      var valueEl = card.querySelector('[data-qty-value]');
      var currentQty = valueEl ? (parseInt(valueEl.textContent) || 0) : 0;
      var originalQty = originalSabores[handle] || 0;
      if (currentQty !== originalQty) changed = true;
    });
    return changed;
  }

  function updateCardStates() {
    var soma = getSomaTotal();
    var atMax = soma >= MAX_CAIXAS;
    var cards = container.querySelectorAll('.personalizar-sabor:not([data-c26-promo])');
    cards.forEach(function(card) {
      var addBtn = card.querySelector('[data-action="add"]');
      var decreaseBtn = card.querySelector('[data-action="decrease"]');
      var valueEl = card.querySelector('[data-qty-value]');

      // Cards não adicionados: opacidade + disabled quando no limite
      if (addBtn) {
        card.style.opacity = atMax ? '0.2' : '';
        addBtn.disabled = atMax;
      }

      // Botão decrease: bloqueia só se este card for o único sabor com qty=1
      if (decreaseBtn && valueEl) {
        var qty = parseInt(valueEl.textContent) || 0;
        var isLastOne = qty === 1 && soma === 1;
        decreaseBtn.style.opacity = isLastOne ? '0.3' : '';
        decreaseBtn.disabled = isLastOne;
      }

      // Botão increase: bloqueia quando total atingiu o máximo
      var increaseBtn = card.querySelector('[data-action="increase"]');
      if (increaseBtn) {
        increaseBtn.style.opacity = atMax ? '0.3' : '';
        increaseBtn.disabled = atMax;
      }
    });
  }

  function updateSaveButton() {
    updateCardStates();
    if (!saveBtn) return;
    var soma = getSomaTotal();
    var totalOk = soma >= 1 && soma <= MAX_CAIXAS;
    var enabled = totalOk && hasChanges();
    saveBtn.disabled = !enabled;
    saveBtn.textContent = 'SALVAR ALTERAÇÕES';
  }

  // ========================================
  // 5. Modal de confirmação + evento salvar
  // ========================================

  var DISCOUNT_RATE = { 1: 0.05, 2: 0.10, 3: 0.15, 4: 0.20 };

  function formatBRL(cents) {
    return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getFlavorsWithPrice(qtyMap) {
    var flavors = [];
    container.querySelectorAll('.personalizar-sabor:not([data-c26-promo])').forEach(function(card) {
      var handle = card.getAttribute('data-sabor-handle');
      var qty = qtyMap[handle] || 0;
      if (qty <= 0) return;
      var imgEl = card.querySelector('.personalizar-sabor__img');
      flavors.push({
        handle: handle,
        title: (card.getAttribute('data-sabor-title') || '').replace(/LIQUIDZ®\s*-\s*/i, '').trim(),
        quantity: qty,
        price: armUnitPrice || (parseInt(card.getAttribute('data-sabor-price')) || 0),
        img: imgEl ? imgEl.getAttribute('src') : ''
      });
    });
    return flavors;
  }

  function getCurrentQtyMap() {
    var map = {};
    container.querySelectorAll('.personalizar-sabor:not([data-c26-promo])').forEach(function(card) {
      var handle = card.getAttribute('data-sabor-handle');
      var valueEl = card.querySelector('[data-qty-value]');
      map[handle] = valueEl ? (parseInt(valueEl.textContent) || 0) : 0;
    });
    return map;
  }

  function calcTotal(flavors) {
    var gross = 0, qty = 0;
    flavors.forEach(function(f) { gross += f.price * f.quantity; qty += f.quantity; });
    var rate = (promoMode === '4locked' && promoDiscount > 0) ? promoDiscount : (DISCOUNT_RATE[Math.min(qty, 4)] || 0);
    var c26CostCents = 0;
    var removedHandles = c26Removals.map(function(r) { return r.handle; });
    Object.keys(c26Boxes).forEach(function(handle) {
      if (removedHandles.indexOf(handle) !== -1) return;
      var b = c26Boxes[handle];
      c26CostCents += Math.round(b.price * 100) * b.qty;
    });
    if (c26PendingAdd) {
      c26CostCents += Math.round(c26PendingAdd.price * 100);
    }
    return { gross: gross, qty: qty, rate: rate, net: Math.round(gross * (1 - rate)) + c26CostCents };
  }

  function showConfirmModal(onConfirm, onClose) {
    var existing = document.getElementById('pb-confirm-modal');
    if (existing) existing.remove();

    if (!document.getElementById('pb-confirm-modal-style')) {
      var s = document.createElement('style');
      s.id = 'pb-confirm-modal-style';
      s.textContent = [
        '.pb-confirm-modal{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;',
        'padding:2rem;box-sizing:border-box;z-index:1001;',
        'background:rgba(0,0,0,0.35);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);}',
        '.pb-confirm-modal__content{background:#fff;border-radius:.8rem;padding:2.4rem;',
        'max-width:44rem;width:100%;position:relative;max-height:80vh;overflow-y:auto;}',
        '.pb-confirm-modal__close{position:absolute;top:1.2rem;right:1.2rem;background:none;border:none;cursor:pointer;padding:.4rem;color:#000;}',
        '.pb-confirm-modal__title{font-size:2rem;font-weight:400;color:#000;margin-bottom:1.6rem;',
        'letter-spacing:-.02em;text-transform:uppercase;font-family:"Almarena Neue";}',
        '.pb-confirm-modal__items{display:flex;flex-direction:column;gap:1rem;margin-bottom:1.2rem;}',
        '.pb-confirm-modal__item{display:flex;align-items:center;gap:.8rem;',
        'font-size:1.3rem;font-family:"Manrope",sans-serif;}',
        '.pb-confirm-modal__item-left{display:flex;flex-direction:column;align-items:flex-start;',
        'gap:.3rem;flex-shrink:0;}',
        '.pb-confirm-modal__item-top{display:flex;align-items:center;gap:.2rem;}',
        '.pb-confirm-modal__thumb{position:relative;width:6rem;height:6rem;flex-shrink:0;}',
        '.pb-confirm-modal__thumb img{width:100%;height:100%;object-fit:cover;border-radius:.4rem;}',
        '.pb-confirm-modal__badge{position:absolute;top:-.3rem;right:-.3rem;background:#000;color:#fff;',
        'font-size:.9rem;padding:.1rem .35rem;border-radius:.3rem;font-weight:700;white-space:nowrap;',
        'font-family:"Manrope",sans-serif;}',
        '.pb-confirm-modal__item-qty{font-size:1.4rem;font-weight:700;color:#000;line-height:1;flex-shrink:0;}',
        '.pb-confirm-modal__item-name{font-size:1rem;color:#808080;line-height:1.3;}',
        '.pb-confirm-modal__dots{flex:1;}',
        '.pb-confirm-modal__item-price{flex-shrink:0;display:flex;flex-direction:column;align-items:flex-end;gap:0;white-space:nowrap;}',
        '.pb-confirm-modal__gross{text-decoration:line-through;color:#aaa;font-size:1.1rem;}',
        '.pb-confirm-modal__net{color:#000;font-weight:700;font-size:1.4rem;}',
        '.pb-confirm-modal__divider{border:none;border-top:1px solid #E0DEDA;margin:1.2rem 0;}',
        '.pb-confirm-modal__totals{display:flex;flex-direction:column;gap:.6rem;margin-bottom:2rem;}',
        '.pb-confirm-modal__total-row{display:flex;align-items:baseline;gap:.4rem;',
        'font-size:1.3rem;font-family:"Manrope",sans-serif;}',
        '.pb-confirm-modal__total-label{flex-shrink:0;color:#808080;}',
        '.pb-confirm-modal__total-dots{flex:1;}',
        '.pb-confirm-modal__total-value{flex-shrink:0;color:#808080;display:flex;align-items:baseline;gap:.3rem;}',
        '.pb-confirm-modal__total-row--new .pb-confirm-modal__total-label{color:#000;font-weight:700;}',
        '.pb-confirm-modal__total-row--new .pb-confirm-modal__total-value{color:#000;}',
        '.pb-confirm-modal__total-row--new .pb-confirm-modal__net{color:#000;font-weight:700;}',
        '.pb-confirm-modal__actions{display:flex;flex-direction:row;gap:.8rem;}',
        '.pb-confirm-modal__btn{width:100%;padding:1.2rem;border-radius:100px;font-size:1.4rem;',
        'font-family:"Almarena Neue",sans-serif;cursor:pointer;font-weight:600;text-transform:uppercase;letter-spacing:.02em;}',
        '.pb-confirm-modal__btn--cancel{background:transparent;color:#000;border:1px solid #000;}',
        '.pb-confirm-modal__btn--confirm{background:#87DD00;color:#000;border:none;}',
        '.pb-confirm-modal__btn--loading{opacity:.7;pointer-events:none;display:inline-flex;align-items:center;justify-content:center;gap:.5rem;}',
        '.pb-confirm-modal__spinner{display:inline-block;width:14px;height:14px;border:2px solid rgba(0,0,0,.2);border-top-color:#000;border-radius:50%;animation:pb-spin .6s linear infinite;}',
        '@keyframes pb-spin{to{transform:rotate(360deg)}}',
      ].join('');
      document.head.appendChild(s);
    }

    var newFlavors = getFlavorsWithPrice(getCurrentQtyMap());
    var oldFlavors = getFlavorsWithPrice(originalSabores);
    var newCalc = calcTotal(newFlavors);
    var oldCalc = calcTotal(oldFlavors);
    var discPct = Math.round(newCalc.rate * 100);

    var itemsHtml = newFlavors.map(function(f) {
      var gross = f.price * f.quantity;
      var net = Math.round(gross * (1 - newCalc.rate));
      var thumbHtml = f.img
        ? '<div class="pb-confirm-modal__thumb">'
          + '<img src="' + f.img + '" alt="' + f.title + '">'
          + (discPct > 0 ? '<span class="pb-confirm-modal__badge">-' + discPct + '%</span>' : '')
          + '</div>'
        : '';
      return '<div class="pb-confirm-modal__item">'
        + '<div class="pb-confirm-modal__item-left">'
        + '<div class="pb-confirm-modal__item-top">'
        + '<span class="pb-confirm-modal__item-qty">' + f.quantity + 'x</span>'
        + thumbHtml
        + '</div>'
        + '<span class="pb-confirm-modal__item-name">' + f.title + '</span>'
        + '</div>'
        + '<span class="pb-confirm-modal__dots"></span>'
        + '<span class="pb-confirm-modal__item-price">'
        + '<span class="pb-confirm-modal__gross">' + formatBRL(gross) + '</span>'
        + '<span class="pb-confirm-modal__net">' + formatBRL(net) + '</span>'
        + '</span>'
        + '</div>';
    }).join('');

    var _removedHandles = c26Removals.map(function(r) { return r.handle; });
    Object.keys(c26Boxes).forEach(function(handle) {
      var b = c26Boxes[handle];
      if (!b || !b.qty) return;
      var title = b.name || handle;
      var _mainCard = container.querySelector('.personalizar-sabor:not([data-c26-promo]):not(.personalizar-sabor--offer)[data-sabor-handle="' + handle + '"]');
      var _mainImgEl = _mainCard ? _mainCard.querySelector('.personalizar-sabor__img') : null;
      var img = _mainImgEl ? _mainImgEl.getAttribute('src') : (C26_FALLBACK_IMG[handle] || b.img || '');
      var priceCents = Math.round(b.price * 100) * b.qty;
      var isRemoved = _removedHandles.indexOf(handle) !== -1;
      var thumbHtml = img
        ? '<div class="pb-confirm-modal__thumb"><img src="' + img + '" alt="' + title + '"></div>'
        : '';
      if (isRemoved) {
        itemsHtml += '<div class="pb-confirm-modal__item" style="opacity:0.35">'
          + '<div class="pb-confirm-modal__item-left">'
          + '<div class="pb-confirm-modal__item-top">'
          + '<span class="pb-confirm-modal__item-qty" style="text-decoration:line-through">' + b.qty + 'x</span>'
          + thumbHtml
          + '</div>'
          + '<span class="pb-confirm-modal__item-name" style="text-decoration:line-through">' + title + '</span>'
          + '</div>'
          + '<span class="pb-confirm-modal__dots"></span>'
          + '<span class="pb-confirm-modal__item-price">'
          + '<span class="pb-confirm-modal__net" style="color:#d00">removido</span>'
          + '</span>'
          + '</div>';
      } else {
        itemsHtml += '<div class="pb-confirm-modal__item" style="opacity:0.55">'
          + '<div class="pb-confirm-modal__item-left">'
          + '<div class="pb-confirm-modal__item-top">'
          + '<span class="pb-confirm-modal__item-qty">' + b.qty + 'x</span>'
          + thumbHtml
          + '</div>'
          + '<span class="pb-confirm-modal__item-name">' + title + ' <span style="font-size:0.85em;color:#aaa">(add-on fixo)</span></span>'
          + '</div>'
          + '<span class="pb-confirm-modal__dots"></span>'
          + '<span class="pb-confirm-modal__item-price">'
          + '<span class="pb-confirm-modal__net">' + formatBRL(priceCents) + '</span>'
          + '</span>'
          + '</div>';
      }
    });

    if (c26PendingAdd) {
      var _addCard = container.querySelector('.personalizar-sabor:not([data-c26-promo]):not(.personalizar-sabor--offer)[data-sabor-handle="' + c26PendingAdd.handle + '"]');
      var _addImgEl = _addCard ? _addCard.querySelector('.personalizar-sabor__img') : null;
      var _addImg = _addImgEl ? _addImgEl.getAttribute('src') : (C26_FALLBACK_IMG[c26PendingAdd.handle] || '');
      var _addPriceCents = Math.round(c26PendingAdd.price * 100);
      var _addThumbHtml = _addImg
        ? '<div class="pb-confirm-modal__thumb"><img src="' + _addImg + '" alt="' + c26PendingAdd.name + '"></div>'
        : '';
      itemsHtml += '<div class="pb-confirm-modal__item">'
        + '<div class="pb-confirm-modal__item-left">'
        + '<div class="pb-confirm-modal__item-top">'
        + '<span class="pb-confirm-modal__item-qty">1x</span>'
        + _addThumbHtml
        + '</div>'
        + '<span class="pb-confirm-modal__item-name">' + c26PendingAdd.name + ' <span style="font-size:0.85em;color:#66E000">(novo add-on)</span></span>'
        + '</div>'
        + '<span class="pb-confirm-modal__dots"></span>'
        + '<span class="pb-confirm-modal__item-price">'
        + '<span class="pb-confirm-modal__net">' + formatBRL(_addPriceCents) + '</span>'
        + '</span>'
        + '</div>';
    }

    var modal = document.createElement('div');
    modal.id = 'pb-confirm-modal';
    modal.className = 'pb-confirm-modal';
    modal.innerHTML = '<div class="pb-confirm-modal__content">'
      + '<button class="pb-confirm-modal__close" aria-label="Fechar">'
      + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20"><path fill="currentColor" d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94L6.28 5.22Z"/></svg>'
      + '</button>'
      + '<h3 class="pb-confirm-modal__title">Resumo de Alterações</h3>'
      + '<div class="pb-confirm-modal__items">' + itemsHtml + '</div>'
      + '<hr class="pb-confirm-modal__divider">'
      + '<div class="pb-confirm-modal__totals">'
      + '<div class="pb-confirm-modal__total-row">'
      + '<span class="pb-confirm-modal__total-label">Valor anterior</span>'
      + '<span class="pb-confirm-modal__total-dots"></span>'
      + '<span class="pb-confirm-modal__total-value">' + formatBRL(oldCalc.net) + '</span>'
      + '</div>'
      + '<div class="pb-confirm-modal__total-row pb-confirm-modal__total-row--new">'
      + '<span class="pb-confirm-modal__total-label">Novo valor</span>'
      + '<span class="pb-confirm-modal__total-dots"></span>'
      + '<span class="pb-confirm-modal__total-value">'
      + (newCalc.rate > 0 ? '<span class="pb-confirm-modal__gross">' + formatBRL(newCalc.gross) + '</span>' : '')
      + '<span class="pb-confirm-modal__net">' + formatBRL(newCalc.net) + '</span>'
      + '</span>'
      + '</div>'
      + '</div>'
      + '<div class="pb-confirm-modal__actions">'
      + '<button class="pb-confirm-modal__btn pb-confirm-modal__btn--cancel">CANCELAR</button>'
      + '<button class="pb-confirm-modal__btn pb-confirm-modal__btn--confirm">CONCLUIR</button>'
      + '</div>'
      + '</div>';

    document.body.appendChild(modal);

    var _saving = false;
    function closeModal() { if (_saving) return; modal.remove(); if (onClose) onClose(); }
    modal.querySelector('.pb-confirm-modal__close').addEventListener('click', closeModal);
    modal.querySelector('.pb-confirm-modal__btn--cancel').addEventListener('click', closeModal);
    var confirmBtn = modal.querySelector('.pb-confirm-modal__btn--confirm');
    confirmBtn.addEventListener('click', function() {
      _saving = true;
      confirmBtn.classList.add('pb-confirm-modal__btn--loading');
      confirmBtn.innerHTML = '<span class="pb-confirm-modal__spinner"></span> Salvando...';
      modal.querySelector('.pb-confirm-modal__btn--cancel').style.display = 'none';
      modal.querySelector('.pb-confirm-modal__close').style.display = 'none';
      onConfirm();
    });
    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  }

  function handleC26Remove(btn) {
    var card = btn.closest('[data-c26-promo]');
    if (!card) return;
    var handle = card.getAttribute('data-sabor-handle');
    var sku = card.getAttribute('data-c26-sku');
    var b = c26Boxes[handle];
    if (!b) return;

    if (card.hasAttribute('data-c26-removing')) {
      card.removeAttribute('data-c26-removing');
      card.classList.remove('personalizar-sabor--removing');
      c26Removals = c26Removals.filter(function(r) { return r.handle !== handle; });
      updateSaveButton();
      return;
    }

    showC26RemoveModal(b.name || handle, b.price, function() {
      c26Removals.push({ handle: handle, sku: sku });
      card.setAttribute('data-c26-removing', '');
      card.classList.add('personalizar-sabor--removing');
      updateSaveButton();
    });
  }

  function handleC26OfferAdd() {
    var offerCard = container.querySelector('[data-c26-offer]');
    if (!offerCard) return;

    if (c26PendingAdd) {
      c26PendingAdd = null;
      offerCard.classList.remove('personalizar-sabor--offer-added');
      var btn = offerCard.querySelector('[data-c26-offer-add]');
      if (btn) btn.textContent = 'Adicionar';
      updateSaveButton();
      return;
    }

    var handle = offerCard.getAttribute('data-sabor-handle');
    var sku = offerCard.getAttribute('data-c26-sku');
    var offer = window._c26Offer;
    if (!offer) return;

    c26PendingAdd = { handle: handle, sku: sku, name: offer.name, price: offer.price };
    offerCard.classList.add('personalizar-sabor--offer-added');
    var btn = offerCard.querySelector('[data-c26-offer-add]');
    if (btn) btn.textContent = 'Desfazer';
    updateSaveButton();
  }

  function showC26RemoveModal(name, price, onConfirm) {
    var existing = document.getElementById('pb-c26-remove-modal');
    if (existing) existing.remove();

    if (!document.getElementById('pb-lose-discount-style')) {
      var s = document.createElement('style');
      s.id = 'pb-lose-discount-style';
      s.textContent = [
        '.pb-lose-modal{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;',
        'padding:2rem;box-sizing:border-box;z-index:1001;',
        'background:rgba(0,0,0,0.35);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);}',
        '.pb-lose-modal__content{background:#fff;border-radius:.8rem;padding:2.4rem;',
        'max-width:40rem;width:100%;position:relative;}',
        '.pb-lose-modal__title{font-size:2rem;font-weight:400;color:#000;margin-bottom:1.2rem;',
        'letter-spacing:-.02em;text-transform:uppercase;font-family:"Almarena Neue";}',
        '.pb-lose-modal__body{font-size:1.3rem;font-family:"Manrope",sans-serif;color:#555;',
        'line-height:1.7;margin-bottom:2rem;}',
        '.pb-lose-modal__hl{color:#000;font-weight:700;}',
        '.pb-lose-modal__actions{display:flex;flex-direction:row;gap:.8rem;}',
        '.pb-lose-modal__btn{width:100%;padding:1.2rem;border-radius:100px;font-size:1.4rem;',
        'font-family:"Almarena Neue",sans-serif;cursor:pointer;font-weight:600;text-transform:uppercase;letter-spacing:.02em;}',
        '.pb-lose-modal__btn--cancel{background:transparent;color:#000;border:1px solid #000;}',
        '.pb-lose-modal__btn--confirm{background:#87DD00;color:#000;border:none;}',
      ].join('');
      document.head.appendChild(s);
    }
    if (!document.getElementById('pb-c26-remove-style')) {
      var s2 = document.createElement('style');
      s2.id = 'pb-c26-remove-style';
      s2.textContent = '.pb-lose-modal__btn--danger{background:#d00;color:#fff;border:none;}';
      document.head.appendChild(s2);
    }

    var priceStr = 'R$ ' + price.toFixed(2).replace('.', ',');
    var modal = document.createElement('div');
    modal.id = 'pb-c26-remove-modal';
    modal.className = 'pb-lose-modal';
    modal.innerHTML = '<div class="pb-lose-modal__content">'
      + '<h3 class="pb-lose-modal__title">Remover oferta promocional</h3>'
      + '<p class="pb-lose-modal__body">'
      + 'Ao remover <span class="pb-lose-modal__hl">' + name + '</span>, você perderá o preço especial de '
      + '<span class="pb-lose-modal__hl">' + priceStr + '/mês</span> e não será possível adicioná-lo novamente por este valor.'
      + '</p>'
      + '<div class="pb-lose-modal__actions">'
      + '<button class="pb-lose-modal__btn pb-lose-modal__btn--cancel">MANTER</button>'
      + '<button class="pb-lose-modal__btn pb-lose-modal__btn--danger">REMOVER</button>'
      + '</div>'
      + '</div>';

    document.body.appendChild(modal);
    modal.querySelector('.pb-lose-modal__btn--cancel').addEventListener('click', function() { modal.remove(); });
    modal.querySelector('.pb-lose-modal__btn--danger').addEventListener('click', function() { modal.remove(); onConfirm(); });
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.remove(); });
  }

  function showLoseDiscountModal(soma, onConfirm) {
    var existing = document.getElementById('pb-lose-discount-modal');
    if (existing) existing.remove();

    if (!document.getElementById('pb-lose-discount-style')) {
      var s = document.createElement('style');
      s.id = 'pb-lose-discount-style';
      s.textContent = [
        '.pb-lose-modal{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;',
        'padding:2rem;box-sizing:border-box;z-index:1001;',
        'background:rgba(0,0,0,0.35);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);}',
        '.pb-lose-modal__content{background:#fff;border-radius:.8rem;padding:2.4rem;',
        'max-width:40rem;width:100%;position:relative;}',
        '.pb-lose-modal__title{font-size:2rem;font-weight:400;color:#000;margin-bottom:1.2rem;',
        'letter-spacing:-.02em;text-transform:uppercase;font-family:"Almarena Neue";}',
        '.pb-lose-modal__body{font-size:1.3rem;font-family:"Manrope",sans-serif;color:#555;',
        'line-height:1.7;margin-bottom:2rem;}',
        '.pb-lose-modal__hl{color:#000;font-weight:700;}',
        '.pb-lose-modal__actions{display:flex;flex-direction:row;gap:.8rem;}',
        '.pb-lose-modal__btn{width:100%;padding:1.2rem;border-radius:100px;font-size:1.4rem;',
        'font-family:"Almarena Neue",sans-serif;cursor:pointer;font-weight:600;text-transform:uppercase;letter-spacing:.02em;}',
        '.pb-lose-modal__btn--cancel{background:transparent;color:#000;border:1px solid #000;}',
        '.pb-lose-modal__btn--confirm{background:#87DD00;color:#000;border:none;}',
      ].join('');
      document.head.appendChild(s);
    }

    var currentPct = Math.round(promoDiscount * 100);
    var newRate = DISCOUNT_RATE[Math.min(soma, 4)] || 0;
    var newPct = Math.round(newRate * 100);
    var caixasLabel = soma === 1 ? '1 caixa' : soma + ' caixas';

    var modal = document.createElement('div');
    modal.id = 'pb-lose-discount-modal';
    modal.className = 'pb-lose-modal';
    modal.innerHTML = '<div class="pb-lose-modal__content">'
      + '<h3 class="pb-lose-modal__title">⚠️ Atenção</h3>'
      + '<p class="pb-lose-modal__body">'
      + 'Ao alterar a quantidade você perde o desconto de <span class="pb-lose-modal__hl">' + currentPct + '%</span> da Semana do Consumidor.<br><br>'
      + 'Com <span class="pb-lose-modal__hl">' + caixasLabel + '</span>, você passa para '
      + '<span class="pb-lose-modal__hl">' + newPct + '%</span> de desconto.'
      + '</p>'
      + '<div class="pb-lose-modal__actions">'
      + '<button class="pb-lose-modal__btn pb-lose-modal__btn--cancel">CANCELAR</button>'
      + '<button class="pb-lose-modal__btn pb-lose-modal__btn--confirm">PROSSEGUIR</button>'
      + '</div>'
      + '</div>';

    document.body.appendChild(modal);
    modal.querySelector('.pb-lose-modal__btn--cancel').addEventListener('click', function() { modal.remove(); });
    modal.querySelector('.pb-lose-modal__btn--confirm').addEventListener('click', function() { modal.remove(); onConfirm(); });
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.remove(); });
  }

  if (saveBtn) {
    saveBtn.addEventListener('click', function() {
      if (saveBtn.disabled) return;

      var soma = getSomaTotal();
      var isLosingPromo = promoMode === '4locked' && soma !== 4;

      function fireConfirm(promoOptOut) {
        var savedMode = promoMode, savedDiscount = promoDiscount;
        if (promoOptOut) { promoMode = 'promo12'; promoDiscount = 0; }

        showConfirmModal(function() {
          var flavors = getSelectedFlavors();
          var flavorsComPreco = getFlavorsWithPrice(getCurrentQtyMap());
          var calcNovo = calcTotal(flavorsComPreco);
          var calcAntigo = calcTotal(getFlavorsWithPrice(originalSabores));
          promoMode = savedMode; promoDiscount = savedDiscount; // restaura antes de despachar
          var payload = { totalCaixas: totalCaixas, sabores: flavors, valor_antes: calcAntigo.net, valor_depois: calcNovo.net, promoOptOut: promoOptOut, c26Removals: c26Removals.slice(), c26PendingAdd: c26PendingAdd ? { handle: c26PendingAdd.handle, sku: c26PendingAdd.sku } : null };
          var event = new CustomEvent('personalizar:salvar', { detail: payload, bubbles: true });
          container.dispatchEvent(event);
        }, function() { // onClose (cancelou o resumo)
          if (promoOptOut) { promoMode = savedMode; promoDiscount = savedDiscount; }
        });
      }

      if (isLosingPromo) {
        showLoseDiscountModal(soma, function() { fireConfirm(true); });
      } else {
        fireConfirm(false);
      }
    });
  }

  // ========================================
  // 6. API pública para pré-preenchimento
  // ========================================

  window.personalizarSabores = {
    preencherSabores: function(saboresMap) {
      originalSabores = {};
      var cards = container.querySelectorAll('.personalizar-sabor:not([data-c26-promo])');
      cards.forEach(function(card) {
        var handle = card.getAttribute('data-sabor-handle');
        var qty = saboresMap[handle] || 0;
        originalSabores[handle] = qty;
        var qtyContainer = card.querySelector('[data-sabor-qty]');
        if (!qtyContainer) return;

        if (qty > 0) {
          qtyContainer.innerHTML = buildQtyControls(qty);
        } else {
          qtyContainer.innerHTML = buildAddButton();
        }
      });
      updateSaveButton();
    },

    setTotalCaixas: function(total) {
      totalCaixas = parseInt(total) || 0;
      container.setAttribute('data-subscription-total', totalCaixas);
      updateSaveButton();
    },

    setArmUnitPrice: function(priceCents) {
      armUnitPrice = parseInt(priceCents) || 0;
    },

    setC26Boxes: function(c26Map) {
      c26Boxes = c26Map || {};
      c26Removals = [];

      var existingPromo = container.querySelector('[data-c26-promo-section]');
      if (existingPromo) existingPromo.remove();

      var handles = Object.keys(c26Boxes).filter(function(h) { return c26Boxes[h] && c26Boxes[h].qty > 0; });
      if (!handles.length) return;

      if (!document.getElementById('pb-c26-promo-style')) {
        var s = document.createElement('style');
        s.id = 'pb-c26-promo-style';
        s.textContent = [
          '.personalizar-sabores__promo-section{margin-top:2rem;padding-top:2rem;border-top:1px solid #E0DEDA;}',
          '.personalizar-sabores__promo-header{display:flex;flex-direction:column;gap:.4rem;margin-bottom:1.2rem;}',
          '.personalizar-sabores__promo-label{font-size:1.4rem;font-weight:400;text-transform:uppercase;letter-spacing:.02em;color:#000;}',
          '.personalizar-sabores__promo-note{font-size:1.2rem;color:#888;line-height:1.4;}',
          '.personalizar-sabores__promo-list{display:flex;flex-direction:column;gap:.8rem;}',
          '.personalizar-sabor--promo .personalizar-sabor__promo-price{font-size:1.1rem;color:#888;font-family:"Manrope",sans-serif;}',
          '.personalizar-sabor--promo .personalizar-sabor__qty{display:flex;align-items:center;gap:.8rem;border:none;min-width:auto;border-radius:0;}',
          '.personalizar-sabor__c26-qty{font-size:1.6rem;font-weight:700;color:#000;min-width:2rem;text-align:center;font-family:"Almarena Neue";}',
          '.personalizar-sabor__trash{background:none;border:none;cursor:pointer;padding:.4rem;color:#999;display:flex;align-items:center;transition:color .15s;}',
          '.personalizar-sabor__trash:hover{color:#d00;}',
          '.personalizar-sabor--removing{opacity:.4;}',
          '.personalizar-sabor--removing .personalizar-sabor__name{text-decoration:line-through;}',
          '.personalizar-sabor--removing .personalizar-sabor__promo-price{text-decoration:line-through;}',
          '.personalizar-sabor--removing .personalizar-sabor__trash{color:#66E000;}',
          '.personalizar-sabor--removing .personalizar-sabor__trash:hover{color:#4db300;}',
        ].join('');
        document.head.appendChild(s);
      }

      var EMOJI = { limonadaTropical:'🍋', morangoKiwi:'🍓🥝', melanciaRoma:'🍉', tangerina:'🍊', jabuticaba:'🔮', maracujaMorango:'☀️', melanciaLimao:'🍉🍋', neutro:'🫧', uva:'🍇', laranja:'🍊' };
      var TRASH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';

      var cardsHtml = handles.map(function(handle) {
        var b = c26Boxes[handle];
        var name = b.name || handle;
        var emoji = EMOJI[handle] || '';
        var mainCard = container.querySelector('.personalizar-sabor:not([data-c26-promo]):not(.personalizar-sabor--offer)[data-sabor-handle="' + handle + '"]');
        var mainImgEl = mainCard ? mainCard.querySelector('.personalizar-sabor__img') : null;
        var img = mainImgEl ? mainImgEl.getAttribute('src') : (C26_FALLBACK_IMG[handle] || b.img || '');
        var priceStr = 'R$ ' + b.price.toFixed(2).replace('.', ',') + '/mês';

        var imgHtml = img
          ? '<div class="personalizar-sabor__image"><img src="' + img + '" alt="' + name + '" class="personalizar-sabor__img" loading="lazy"></div>'
          : '';

        return '<div class="personalizar-sabor personalizar-sabor--promo" data-c26-promo data-c26-sku="' + (b.sku || '') + '" data-sabor-handle="' + handle + '">'
          + '<div class="personalizar-sabor__inner">'
          + imgHtml
          + '<div class="personalizar-sabor__info">'
          + '<span class="personalizar-sabor__name font-almarena">' + name + ' ' + emoji + '</span>'
          + '<span class="personalizar-sabor__promo-price">' + priceStr + '</span>'
          + '</div>'
          + '<div class="personalizar-sabor__qty">'
          + '<span class="personalizar-sabor__c26-qty">' + b.qty + '</span>'
          + '<button type="button" class="personalizar-sabor__trash" data-c26-remove aria-label="Remover">' + TRASH_SVG + '</button>'
          + '</div>'
          + '</div>'
          + '</div>';
      }).join('');

      var sectionHtml = '<div class="personalizar-sabores__promo-section" data-c26-promo-section>'
        + '<div class="personalizar-sabores__promo-header">'
        + '<span class="personalizar-sabores__promo-label font-almarena">Caixas promocionais</span>'
        + '<span class="personalizar-sabores__promo-note font-manrope">Itens adicionados como oferta especial.</span>'
        + '</div>'
        + '<div class="personalizar-sabores__promo-list">'
        + cardsHtml
        + '</div>'
        + '</div>';

      var saveBar = container.querySelector('.personalizar-sabores__save-bar');
      if (saveBar) {
        saveBar.insertAdjacentHTML('beforebegin', sectionHtml);
      } else if (saveBtn) {
        saveBtn.insertAdjacentHTML('beforebegin', sectionHtml);
      } else {
        container.insertAdjacentHTML('beforeend', sectionHtml);
      }
    },

    setPromoMode: function(mode, discount) {
      promoMode = mode || 'normal';
      promoDiscount = typeof discount === 'number' ? discount : 0;
      updateSaveButton();
    },

    getEstado: function() {
      return {
        totalCaixas: totalCaixas,
        somaAtual: getSomaTotal(),
        sabores: getSelectedFlavors(),
        c26Removals: c26Removals.slice(),
        c26PendingAdd: c26PendingAdd ? { handle: c26PendingAdd.handle, sku: c26PendingAdd.sku } : null
      };
    },

    showC26Offer: function(offer) {
      window._c26Offer = offer;
      c26PendingAdd = null;

      var existing = container.querySelector('[data-c26-offer]');
      if (existing) existing.remove();
      if (!offer) return;

      var offerColor = offer.color || '#452272';
      var offerTextColor = offer.textColor || '#fff';
      var offerBadgeTagTextColor = offer.badgeTagTextColor || offerColor;
      if (!document.getElementById('pb-c26-offer-style')) {
        var s = document.createElement('style');
        s.id = 'pb-c26-offer-style';
        s.textContent = [
          '.personalizar-sabores__offer{margin-bottom:1.6rem;border:2px solid ' + offerColor + ';border-radius:1.2rem;overflow:hidden;}',
          '.personalizar-sabores__offer-badge{background:' + offerColor + ';color:' + offerTextColor + ';font-size:1.1rem;font-weight:700;',
          'text-transform:uppercase;padding:.5rem 1.2rem;font-family:"Almarena Neue",sans-serif;letter-spacing:.02em;',
          'display:flex;align-items:center;justify-content:space-between;}',
          '.personalizar-sabores__offer-badge-tag{background:#fff;color:' + offerBadgeTagTextColor + ';font-size:.9rem;font-weight:700;',
          'padding:.2rem .6rem;border-radius:4px;margin-left:.8rem;}',
          '.personalizar-sabor--offer .personalizar-sabor__qty{border:none;min-width:auto;border-radius:0;}',
          '.personalizar-sabor--offer-added{background:#f3eefa;}',
          '.personalizar-sabor__offer-prices{display:flex;align-items:baseline;font-family:"Manrope",sans-serif;}',
          '.personalizar-sabor__offer-old{font-size:1.1rem;color:#999;text-decoration:line-through;}',
          '.personalizar-sabor__offer-new{font-size:1.3rem;font-weight:700;color:' + offerColor + ';}',
          '.personalizar-sabor__offer-lifetime{font-size:1rem;color:#888;font-family:"Manrope",sans-serif;}',
          '.personalizar-sabor__offer-btn{background:' + offerColor + ';color:' + offerTextColor + ';border:none;border-radius:6.4rem;',
          'padding:1rem 2rem;font-size:1.3rem;font-weight:400;cursor:pointer;font-family:"Almarena Neue";white-space:nowrap;}',
          '.personalizar-sabor--offer-added .personalizar-sabor__offer-btn{background:transparent;color:' + offerColor + ';border:1px solid ' + offerColor + ';}',
          '@media(max-width:749px){',
          '.personalizar-sabor__offer-prices{flex-wrap:wrap;}',
          '}',
          '@media screen and (min-width:990px){',
          '.personalizar-sabor__offer-prices{gap:.5rem;}',
          '}',
        ].join('');
        document.head.appendChild(s);
      }

      var EMOJI = { limonadaTropical:'🍋', morangoKiwi:'🍓🥝', melanciaRoma:'🍉', tangerina:'🍊', jabuticaba:'🔮', maracujaMorango:'☀️', melanciaLimao:'🍉🍋', neutro:'🫧', uva:'🍇', laranja:'🍊' };
      var mainCard = container.querySelector('.personalizar-sabor:not([data-c26-promo]):not(.personalizar-sabor--offer)[data-sabor-handle="' + offer.handle + '"]');
      var mainImgEl = mainCard ? mainCard.querySelector('.personalizar-sabor__img') : null;
      var img = offer.img || (mainImgEl ? mainImgEl.getAttribute('src') : (C26_FALLBACK_IMG[offer.handle] || ''));
      var emoji = EMOJI[offer.handle] || '';
      var originalPrice = offer.originalPrice || 104.90;
      var oldPriceStr = 'R$ ' + originalPrice.toFixed(2).replace('.', ',');
      var newPriceStr = 'R$ ' + offer.price.toFixed(2).replace('.', ',') + '/mês';
      var discountPct = Math.round((1 - offer.price / originalPrice) * 100);

      var imgHtml = img
        ? '<div class="personalizar-sabor__image"><img src="' + img + '" alt="' + offer.name + '" class="personalizar-sabor__img" loading="lazy"></div>'
        : '';

      var html = '<div class="personalizar-sabores__offer" data-c26-offer data-sabor-handle="' + offer.handle + '" data-c26-sku="' + offer.sku + '">'
        + '<div class="personalizar-sabores__offer-badge font-almarena">'
        + '<span>Oferta especial</span>'
        + '<span class="personalizar-sabores__offer-badge-tag">' + discountPct + '% OFF</span>'
        + '</div>'
        + '<div class="personalizar-sabor personalizar-sabor--offer">'
        + '<div class="personalizar-sabor__inner">'
        + imgHtml
        + '<div class="personalizar-sabor__info">'
        + '<span class="personalizar-sabor__name font-almarena">' + offer.name + ' ' + emoji + '</span>'
        + '<div class="personalizar-sabor__offer-prices">'
        + '<span class="personalizar-sabor__offer-old">' + oldPriceStr + '</span>'
        + '<span class="personalizar-sabor__offer-new">' + newPriceStr + '</span>'
        + '</div>'
        + '<span class="personalizar-sabor__offer-lifetime font-manrope">Desconto vitalício</span>'
        + '</div>'
        + '<div class="personalizar-sabor__qty">'
        + '<button type="button" class="personalizar-sabor__offer-btn" data-c26-offer-add>Adicionar</button>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';

      var header = container.querySelector('.personalizar-sabores__header');
      if (header) {
        header.insertAdjacentHTML('beforebegin', html);
      } else {
        container.insertAdjacentHTML('afterbegin', html);
      }

    },

    disableSaveButton: function() {
      if (!saveBtn) return;
      saveBtn.disabled = true;
    }
  };

  // Handler para botão "Adicionar +" dentro do modal de ingredientes
  // O modal é movido para document.body pelo Dawn, então precisa de listener no document
  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('[data-modal-add-flavor]');
    if (!addBtn) return;

    var flavorIndex = addBtn.getAttribute('data-modal-add-flavor');
    var card = container.querySelector('[data-sabor-index="' + flavorIndex + '"]');
    if (!card) return;

    var qtyContainer = card.querySelector('[data-sabor-qty]');
    if (!qtyContainer) return;

    var valueEl = qtyContainer.querySelector('[data-qty-value]');
    if (valueEl) {
      var current = parseInt(valueEl.textContent) || 0;
      var somaAtual = getSomaTotal();

      if (somaAtual < MAX_CAIXAS) {
        valueEl.textContent = current + 1;
      }
    } else {
      qtyContainer.innerHTML = buildQtyControls(1);
    }

    updateSaveButton();

    var modal = addBtn.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    }
  });

  updateSaveButton();
});

